module.exports = __webpack_public_path__ + "static/media/jilongshan1.ecf7635c.webp";